const TextInput = ({ placeholder, label, inputStyle='normal', disabled=false, value, onChange, name='username', id='username-id', autoComplete='off' }) => {

    const getInputStyle = (style) => {
        switch (style) {
            case 'normal':
                return 'bg-white leading-[20px] px-[16px] py-[13px] w-full border-nborder border-[1px] rounded-[10px] text-[14px] text-tprimary placeholder-tlight outline-none focus:border-tprimary transition-all mb-[24px] rubik';
            case 'error':
                return 'border-red-500 border-[1px] rounded-[5px] px-[15px] py-[10px]';
            default:
                return 'border-tprimary border-[1px] rounded-[5px] px-[15px] py-[10px]';
        }
    }

    const input = <input name={name} id={id} autoComplete={autoComplete} type="text" disabled={disabled} placeholder={placeholder} className={getInputStyle(inputStyle)} value={value} onChange={onChange} />;

    if (label) {
        return (
            <div>
                <label htmlFor={id} className='block text-tlight text-[13px] font-[500] mb-[8px] rubik'>{label}</label>
                {input}
            </div>
        );
    }

    return input;

};

export default TextInput;
